import { useEffect } from 'react'
import { useAuth } from 'react-oidc-context'
import * as CookieConsent from 'vanilla-cookieconsent'
import tracker from '../openreplay'

const ANALYTICS_CATEGORY = 'analytics'

export const OpenReplayTracker = () => {
  const auth = useAuth()
  const email = auth.user?.profile.email

  useEffect(() => {
    if (!process.env.OPENREPLAY_PROJECT_KEY) return

    let started = false
    const startIfConsented = () => {
      if (started) return
      if (!CookieConsent.acceptedCategory(ANALYTICS_CATEGORY)) return
      started = true
      tracker.start().catch(() => {
        started = false
      })
    }

    startIfConsented()
    window.addEventListener('cc:onConsent', startIfConsented)
    window.addEventListener('cc:onChange', startIfConsented)
    return () => {
      window.removeEventListener('cc:onConsent', startIfConsented)
      window.removeEventListener('cc:onChange', startIfConsented)
    }
  }, [])

  useEffect(() => {
    if (!email) return
    if (!CookieConsent.acceptedCategory(ANALYTICS_CATEGORY)) return
    tracker.setUserID(email)
  }, [email])

  return null
}
